import { render, staticRenderFns } from "./SkeletonPendingActionsSlider.vue?vue&type=template&id=726264b0"
import script from "./SkeletonPendingActionsSlider.vue?vue&type=script&lang=js"
export * from "./SkeletonPendingActionsSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports